var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55611 24H15.4439C17.7612 24 18.9142 22.8246 18.9142 20.4962V10.3322H10.8096C9.37677 10.3322 8.70525 9.64919 8.70525 8.21636V0H3.55611C1.2502 0 0.0857849 1.18639 0.0857849 3.51522V20.4962C0.0857849 22.8356 1.2502 24 3.55611 24ZM10.8435 8.79857H18.791C18.7127 8.33958 18.3879 7.89158 17.862 7.34328L11.6827 1.06364C11.1678 0.526328 10.6978 0.201552 10.2274 0.122746V8.19439C10.2274 8.59701 10.4404 8.79857 10.8435 8.79857ZM5.1905 15.1795C4.73152 15.1795 4.40674 14.8547 4.40674 14.4181C4.40674 13.9811 4.73152 13.6568 5.19002 13.6568H13.8205C14.2685 13.6568 14.6157 13.9816 14.6157 14.4177C14.6157 14.8547 14.2685 15.179 13.821 15.179L5.1905 15.1795ZM5.1905 19.4441C4.73152 19.4441 4.40674 19.1193 4.40674 18.6827C4.40674 18.2462 4.73152 17.9214 5.19002 17.9214H13.8205C14.2685 17.9214 14.6157 18.2462 14.6157 18.6827C14.6157 19.1193 14.2685 19.4441 13.821 19.4441H5.1905Z",
    fill: "#F7A600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.a02d8c983cd550f273926cccb35fe312.svg";
export { ForwardRef as ReactComponent };